import {StrictMode} from "react";
import ReactDOM from "react-dom";
import App from "./app";

import "styles/index.scss";
import "styles/index.less";

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);
